module.exports = __webpack_public_path__ + "static/media/hero1.188885d8.png";